import Lottie from 'lottie-react';
import PropTypes from 'prop-types';

const LottieAnimation = (props) => {
  const {
    lottie,
    height = '300px',
    width = '300px',
    loop = false,
    autoplay = true,
  } = props;

  return (
    <Lottie
      autoplay={autoplay}
      loop={loop}
      animationData={lottie}
      style={{ height, width }}
    />
  );
};

LottieAnimation.propTypes = {
  lottie: PropTypes.object.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  loop: PropTypes.bool,
  autoplay: PropTypes.bool,
};

export default LottieAnimation;
